module.exports = __webpack_public_path__ + "static/media/1_r_lampa_64.74_0.6adf79fc.png";